import { render } from "./About.vue?vue&type=template&id=dee451b0"
const script = {}

import exportComponent from "/opt/render/project/src/node_modules/.pnpm/vue-loader@16.8.1_webpack@4.46.0/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__